import * as runtime from '@/api/runtime'
import {
  SearchSynonymGroupRequestToJSON,
  CreateSynonymGroupRequestToJSON,
  DeleteSynonymGroupRequest,
  GetSynonymGroupRequestToJSON,
  SynonymGroup,
  DeleteSynonymGroupRequestToJSON,
  CreateSynonymGroupRequest,
  GetSynonymGroupRequest,
  SearchSynonymGroupRequest,
  SynonymGroupFromJSON,
  UpdateSynonymGroupRequest,
  UpdateSynonymGroupRequestToJSON
} from '@/api'
import { HTTPQuery } from '@/api/runtime'

export class SynonymGroupApi extends runtime.BaseAPI {
  /**
   * 同義語グループを検索する
   * 同義語グループ検索
   */
  async searchSynonymGroup(
    request: SearchSynonymGroupRequest
  ): Promise<SynonymGroup[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(SearchSynonymGroupRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      '/synonym-group/search',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SynonymGroupFromJSON)
    ).value()
  }

  /**
   * 同義語グループを取得する
   * 同義語グループ取得
   */
  async getSynonymGroup(
    request: GetSynonymGroupRequest
  ): Promise<SynonymGroup> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetSynonymGroupRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet('/synonym-group', queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      SynonymGroupFromJSON(jsonValue)
    ).value()
  }

  /**
   * 同義語グループを作成する
   * 同義語グループ作成
   */
  async createSynonymGroup(
    request: CreateSynonymGroupRequest
  ): Promise<number> {
    const bodyParameters: runtime.HTTPBody = CreateSynonymGroupRequestToJSON(
      request
    )
    const response = await this.requestPost('/synonym-group', bodyParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.env_synonym_group)
    ).value()
  }

  /**
   * 同義語グループを更新する
   * 同義語グループ更新
   */
  async updateSynonymGroup(
    request: UpdateSynonymGroupRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateSynonymGroupRequestToJSON(
      request
    )
    const response = await this.requestPut('/synonym-group', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 同義語グループを削除する
   * 同義語グループ削除
   */
  async deleteSynonymGroup(
    request: DeleteSynonymGroupRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = DeleteSynonymGroupRequestToJSON(
      request
    )
    const response = await this.requestDelete('/synonym-group', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }
}
